import React from "react";

export default function PageHero({ eyebrow, title, text, img, testid }) {
    return (
        <section className="relative overflow-hidden bg-[#0b2545]" data-testid={testid}>
            <img src={img} alt="" className="absolute inset-0 w-full h-full object-cover opacity-50" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0b2545] via-[#0b2545]/85 to-[#0b2545]/20" />
            <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-24 kz-rise">
                <div className="kz-eyebrow text-[#f26b1d]">{eyebrow}</div>
                <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-50 mt-3 max-w-2xl leading-tight">{title}</h1>
                {text && <p className="text-blue-100/85 mt-5 max-w-xl leading-relaxed">{text}</p>}
            </div>
        </section>
    );
}
